// Box-Muller normal sample
export function gaussian(mean = 0, stdev = 1): number {
  const u = 1 - Math.random();
  const v = Math.random();
  return mean + stdev * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}

export function clamp(x: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, x));
}

// Ornstein-Uhlenbeck mean-reverting step.
export function ouStep(x: number, mean: number, kappa: number, sigma: number): number {
  return x + kappa * (mean - x) + gaussian(0, sigma);
}

// Log-normal sample given desired median and p95.
export function logNormalFromMedianP95(median: number, p95: number): number {
  const mu = Math.log(median);
  const sigma = Math.max(0.01, (Math.log(p95) - mu) / 1.645);
  return Math.exp(gaussian(mu, sigma));
}

export function poissonInterval(meanMs: number): number {
  // exponential inter-arrival → Poisson process
  const u = 1 - Math.random();
  return -Math.log(u) * meanMs;
}

// Round a USD notional to a tidy human-looking number.
export function tidyUsd(v: number): number {
  if (v >= 100_000) return Math.round(v / 10_000) * 10_000;
  if (v >= 10_000) return Math.round(v / 1000) * 1000;
  return Math.max(100, Math.round(v / 100) * 100);
}

// Is the current UTC time inside an "active" trading window (US hours)?
export function isActiveHours(now = Date.now()): boolean {
  const h = new Date(now).getUTCHours();
  return h >= 13 && h < 21;
}

export function pickWeighted<T>(choices: Array<[T, number]>): T {
  const total = choices.reduce((s, [, w]) => s + w, 0);
  let r = Math.random() * total;
  for (const [c, w] of choices) {
    r -= w;
    if (r <= 0) return c;
  }
  return choices[choices.length - 1][0];
}
